import axios from "axios";
import { API } from "./consts";

const api = axios.create({
  baseURL: API,
  headers: {
    "X-Auth-Origin": "TDVS",
  },
});

api.interceptors.request.use(
  function(config) {
    let token = "";
    token = sessionStorage.getItem("token");

    if (token) config.headers["Authorization"] = token;
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem("uniclare-token");
//   if (token) {
//     config.headers["Authorization"] = `${token}`;
//   }
//   return config;
// });

// api.interceptors.response.use(
//   (response) => response,

//   (error) => {
//     if (error.response && error.response.status === 401) {
//       alert("Session has expired. Please log in again.");
//       window.location.href = "/"; // Redirect to login page
//     }
//     return Promise.reject(error);
//   }
// );

export default api;
